const ProductMark = ({ product, size = 'md' }) => (
  <span className={`product-mark product-mark--${size}`} data-product={product.accent} aria-hidden="true">
    <span />
  </span>
);

export default ProductMark;
